export default {"src":"/uk/_next/static/media/hybrid-app-intro-screen-one.a19df8df.svg","height":148,"width":300,"blurWidth":0,"blurHeight":0};